import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SEO = {
  pl: {
    title: 'AvePark - Całoroczny kryty skatepark w Warszawie',
    description: 'Całoroczny kryty skatepark w Warszawie. BMX, hulajnoga, deskorolka, rolki.'
  },
  en: {
    title: 'AvePark - Indoor Skatepark in Warsaw',
    description: 'Indoor skatepark in Warsaw open all year round. BMX, scooter, skateboard, inline skates.'
  },
  de: {
    title: 'AvePark - Indoor-Skatepark in Warschau',
    description: 'Ganzjährig geöffneter Indoor-Skatepark in Warschau. BMX, Roller, Skateboard, Inlineskates.'
  },
  uk: {
    title: 'AvePark - Критий скейтпарк у Варшаві',
    description: 'Цілорічний критий скейтпарк у Варшаві. BMX, самокат, скейтборд, ролики.'
  }
};

/**
 * Updates document title, meta description, and <html lang> based on current language.
 */
export function useDocumentMeta() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const currentLang = lang || i18n.language?.split('-')[0] || 'pl';

  useEffect(() => {
    const seo = SEO[currentLang] || SEO.en;
    document.documentElement.lang = currentLang;
    document.title = seo.title;

    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', seo.description);
  }, [currentLang]);
}
